/** @jsx jsx */
import { jsx } from "theme-ui"
// import { useTranslation } from "react-i18next"
// import { DateTime } from "luxon"

// import Date from "../../atoms/Date"
import Pin from "../../atoms/Pin"
import List from "../../atoms/List"
import Thumbnail from "../Thumbnail"

// import { ReactComponent as CalendarIcon } from "../../../images/icons/calendar.svg"
import { ReactComponent as PinIcon } from "../../../images/icons/pin.svg"

export default function ProjectThumbnail({
  project: { date, coverImage, description, title, slug, address },
  index,
}) {
  // const { i18n } = useTranslation()

  return (
    <Thumbnail
      to={`/project/${slug.current}`}
      date={date}
      image={coverImage.asset.fluid}
      title={title}
      subtitle={description}
      width={700}
      height={380}
      index={index}
    >
      <List horizontal style={{ gridGap: 2, mt: 3 }}>
        {address && address.city && (
          <li>
            <Pin icon={<PinIcon width={8} height={10} />}>{address.city}</Pin>
          </li>
        )}
        {/* {date && (
          <li>
            <Pin icon={<CalendarIcon width={11} height={10} />}>
              <Date value={date} format={DateTime.DATE_SHORT} />
            </Pin>
          </li>
        )} */}
      </List>
    </Thumbnail>
  )
}
